import Styled from "styled-components";

export const Search = Styled.div`

button{
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 44px;
    min-height: 44px;
    width: 44px;
    height: 44px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
}

svg{
    height: 24px;
    width: 24px;
    cursor: pointer;
    fill: var(--header-color) !important;
}
`;
